import AirplaneSprite from './AirplaneSprite';
export default AirplaneSprite;